import axios from "axios";
let flgBackend = null;
let baseUrl;
let opcErrorPonerMantenimiento;

const axiosTraza = async (history = null) => {
  if (flgBackend === null) {
    baseUrl = await fetch("./config.json");
    baseUrl = await baseUrl.json();
    opcErrorPonerMantenimiento = await baseUrl.opcErrorPonerMantenimiento;
    baseUrl = await baseUrl.wsTraza;
    flgBackend = true;
  }

  let headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    Accept: "application/json",
  };

  if (sessionStorage.token) {
    headers.Authorization = `Bearer ${sessionStorage.token}`;
  }

  const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers,
  });

  axiosInstance.interceptors.response.use(
    (response) =>
      new Promise((resolve, _reject) => {
        resolve(response);
      }),
    (error) => {
      if (!error.response) {
        if (opcErrorPonerMantenimiento) {
          sessionStorage.removeItem("token");
          let config = localStorage.getItem("config");
          config = JSON.parse(config);
          const dtoMantenimiento = {
            mantenimiento: true,
            mantenimientoMsj:
              "El portal se encuentra momentaneamente en mantenimiento. Por favor, intente nuevamente en unos minutos",
          };
          config = { ...config, ...dtoMantenimiento };
          localStorage.setItem("config", JSON.stringify(config));
        }
        return new Promise((_resolve, reject) => {
          reject(error);
        });
      }
      if (error.response.status === 503) {
        if (opcErrorPonerMantenimiento) {
          sessionStorage.removeItem("token");
          let config = localStorage.getItem("config");
          config = JSON.parse(config);
          const dtoMantenimiento = {
            mantenimiento: true,
            mantenimientoMsj:
              "El portal se encuentra momentaneamente en mantenimiento. Por favor, intente nuevamente en unos minutos",
          };
          config = { ...config, ...dtoMantenimiento };
          localStorage.setItem("config", JSON.stringify(config));
        }
      } else {
        return new Promise((_resolve, reject) => {
          reject(error);
        });
      }
    }
  );
  return axiosInstance;
};

export default axiosTraza;
